import React from 'react';
import { AvailableCartLevelGifts } from '@kidslabs/module-flash-sale';
import type { AfterCartListComponentProps } from './after-cart-list-component.types';

/**
 * AfterCartListComponent for Nova cart
 * Renders AvailableCartLevelGifts with gift list after cart items
 *
 * Matches mobile module-theme-hermes implementation:
 * @see mobile-ecommerce/applications/module-theme-hermes/src/modules/quote/components/after-cart-list/after-cart-list.tsx
 */
export const AfterCartListComponent = ({
    showActionButton,
    variant = 'detailed',
    isMobile = true,
    showSelectedOnly = false,
}: AfterCartListComponentProps) => {
    return (
        <AvailableCartLevelGifts
            variant={variant}
            showActionButton={showActionButton}
            isMobile={isMobile}
            showSelectedOnly={showSelectedOnly}
        />
    );
};
